import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Router} from '@angular/router';
import {ResponseHandlerService} from '../common-service/response-handler.service';
import {catchError, map} from "rxjs/operators";
import {RoutesConstants} from '@coreconstant';

export interface httpConfig {
    url?: any,
    method?: any,
    data?: any,
    filterParameters?: any,
    isRequestModelUsed?: boolean
    params?: HttpParams,
}

@Injectable({
    providedIn: 'root'
})

export class HttpService {
    backendBaseUrlApis = environment.backendBaseUrlApis;
    routesConstants = RoutesConstants

    constructor(
        private _router: Router,
        private _http: HttpClient,
        private _responseHandlerService: ResponseHandlerService,
    ) {
    }

    /**
     * Initializes an HTTP request with the given configuration and handles the response and errors.
     * @param {httpConfig} requestParams - The configuration object containing request details such as URL, method, headers, and body.
     * @return {Observable<any>} An observable that emits the server's response or handles errors based on the response status.
     */
    init(requestParams: httpConfig) {
        let headers: HttpHeaders = this.getHeaders(requestParams);
        return this.request(requestParams, headers).pipe(
            map(response => {
                return response;
            }, (error) => {
                return error;
            }),
            catchError((error: any) => {
                if (error["status"] == 401 || error.error["code"] == 401) {
                    return false
                } else if (error.error["code"] == 403 || error["status"] == 403 || error["status"] == 400 || error["status"] == 422 || error.error["code"] == 422 || error["status"] == 500 || error.error["code"] == 500 || error["status"] == 502 || error.error["code"] == 502 || error["status"] == 503 || error.error["code"] == 503) {
                    this._responseHandlerService.handleAPIErrorResponse(error.error);
                    return false
                } else if (error["status"] == 404 || error.error["code"] == 404) {
                    let requestUrl = error.url
                    if (requestUrl.includes('/venue/')) {
                        this._router.navigate(['/' + this.routesConstants.VENUE_NAVIGATION]); // Redirect to global 404 page
                        return false
                    } else if (requestUrl.includes('/vendor/')) {
                        this._router.navigate(['/' + this.routesConstants.VENDOR_NAVIGATION]);
                        return false
                    } else if (requestUrl.includes('/blog/')) {
                        this._router.navigate(['/' + this.routesConstants.WEDSPIRATION]);
                        return false
                    } else {
                        this._router.navigate(['/404']);
                        return false
                    }
                } else {
                    return error
                }
            }));
    }

    /**
     * Sends an HTTP request with the specified configuration and headers.
     * @param {httpConfig} requestParams - The configuration object for the HTTP request, including method, URL, data, parameters, and other options.
     * @param {HttpHeaders} headers - The HTTP headers to include in the request.
     * @return {Observable<any>} An observable that emits the response of the HTTP request.
     */
    request(requestParams: httpConfig, headers: HttpHeaders) {
        let requestUrl = requestParams.url

        if (requestParams.isRequestModelUsed) {
            requestUrl = this.getUrlWithFilterParams(requestParams.url, requestParams.filterParameters)
        }

        return this._http.request(requestParams.method, this.backendBaseUrlApis + requestUrl, {
            body: requestParams.data,
            params: requestParams.params,
            headers: headers
        });
    }

    /**
     * Sends a GET request to the specified URL with the provided parameters and headers.
     * @param {httpConfig} [requestParams] - Optional configuration for the HTTP request,
     * including the URL, filter parameters, and headers.
     * @return {Observable<HttpResponse<any>>} An observable containing the HTTP response.
     */
    get(requestParams?: httpConfig) {
        const fullURL = this.getUrlWithFilterParams(requestParams.url, requestParams.filterParameters);
        const headers = this.getHeaders(requestParams);
        return this._http.get(fullURL, {
            headers: headers,
            observe: 'response'
        });
    }

    /**
     * Generates and returns HTTP headers for the request.
     * @param {httpConfig} configuration - The configuration object for the HTTP request.
     * @return {HttpHeaders} A set of headers configured with platform and optional authorization token.
     */
    private getHeaders(configuration: httpConfig): HttpHeaders {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append("platform", "frontend");
        return headers;
    }

    /**
     * Constructs a complete URL by appending backend base URL and optional filter parameters.
     * @param {string} url - The endpoint URL to which the base backend URL is appended.
     * @param {any} [requestParamModel] - An optional object containing methods or properties to generate query parameters.
     * @return {string} The concatenated URL including backend base URL and query parameters, if provided.
     */
    getUrlWithFilterParams(url: string, requestParamModel?: any): string {
        let newURL: string = this.backendBaseUrlApis + url;
        if (requestParamModel) {
            newURL += requestParamModel.getParams();
        }
        return newURL;
    }

}
